var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Instagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface81971083"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.546875 2 C 5.390625 2 2 5.390625 2 9.546875 L 2 20.460938 C 2 24.609375 5.390625 28 9.546875 28 L 20.460938 28 C 24.609375 28 28 24.609375 28 20.453125 L 28 9.546875 C 28 5.390625 24.609375 2 20.453125 2 Z M 9.546875 4 L 20.453125 4 C 23.53125 4 26 6.46875 26 9.546875 L 26 20.453125 C 26 23.53125 23.53125 26 20.460938 26 L 9.546875 26 C 6.46875 26 4 23.53125 4 20.460938 L 4 9.546875 C 4 6.46875 6.46875 4 9.546875 4 Z M 23 6 C 22.445312 6 22 6.445312 22 7 C 22 7.554688 22.445312 8 23 8 C 23.554688 8 24 7.554688 24 7 C 24 6.445312 23.554688 6 23 6 Z M 15 8 C 11.148438 8 8 11.148438 8 15 C 8 18.851562 11.148438 22 15 22 C 18.851562 22 22 18.851562 22 15 C 22 11.148438 18.851562 8 15 8 Z M 15 10 C 17.773438 10 20 12.226562 20 15 C 20 17.773438 17.773438 20 15 20 C 12.226562 20 10 17.773438 10 15 C 10 12.226562 12.226562 10 15 10 Z M 15 10 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram);
export default __webpack_public_path__ + "static/media/icons8-instagram.dfb0beefa83f31554d3db9df01c4a71c.svg";
export { ForwardRef as ReactComponent };